export const isMobilePhone = () => {
  if (typeof navigator === 'undefined') return false;

  const userAgent = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const isIPhone = /iPhone/i.test(userAgent) || /iPhone/i.test(platform);
  const isAndroidPhone = /Android/i.test(userAgent) && /Mobile/i.test(userAgent);
  const isWindowsPhone = /Windows Phone/i.test(userAgent);
  const isGenericPhone = /Mobile/i.test(userAgent) && !/iPad|Tablet/i.test(userAgent);

  return isIPhone || isAndroidPhone || isWindowsPhone || isGenericPhone;
};
